import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import FilteredTableDataRow from './FilteredTableDataRow';
import Paper from '@mui/material/Paper';
import { IssueKeys } from '../../shared/constants/IssueAndServiceKeys';

export default function FilteredTable({ issues, cols, dropdownTable, type }) {
  return issues?.length ? (
    <TableContainer component={Paper} sx={{ height: '100%', maxHeight: '100%', overflow: 'auto' }}>
      <Table sx={{ minWidth: 0, m: 0 }} aria-label="simple table" stickyHeader>
        <TableHead>
          <TableRow sx={{ minHeight: '6vh', height: '6vh', maxHeight: '6vh' }}>
            {cols.map((col) => (
              <TableCell
                sx={
                  col === IssueKeys.topic
                    ? {
                        width: '50%',
                        px: '16px',
                        borderBottom: 'black solid 1.5px',
                        minHeight: '6vh',
                        height: '6vh',
                        maxHeight: '6vh',
                      }
                    : {
                        maxWidth: '30%',
                        px: '16px',
                        borderBottom: 'black solid 1.5px',
                        minHeight: '6vh',
                        height: '6vh',
                        maxHeight: '6vh',
                      }
                }
                key={col}
                align="left"
              >
                {col}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {issues.map((issue, index) => (
            <FilteredTableDataRow
              type={type}
              key={issue.id}
              issue={issue}
              columns={cols}
              dropdownTable={dropdownTable}
              isStripedRow={index % 2}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    <h2>No data</h2>
  );
}
